@custom-media --mobile (max-width: 768px);

.stateContainer {
  padding-top: 1em;
  border-top: solid 0.1em var(--mediumSilver);
  margin-bottom: 1em;
}

.stateInputs {
  display: flex;
  justify-content: flex-end;

  @media (--mobile) {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

.stateInput {
  flex-grow: 1;
  flex-basis: 100%;
  max-width: 12em;

  @media (--mobile) {
    flex-basis: 100%;
    margin-top: 1em;
    max-width: 100%;
  }
}

.previewHeader {
  padding-bottom: 0;
}

.previewLanguageContainer {
  display: flex;
  margin-bottom: 0.9em;
}

.languageText {
  padding: 0 0 0.125em;
  margin-left: 0.1em;
  margin-right: 0.5em;
  color: var(--gray) !important;
  font-weight: 600;
  font-size: 0.9em;

  &:hover {
    color: var(--darkBlue) !important;
  }

  &:focus {
    outline: none;
  }
}

.activeLanguageText {
  color: var(--blueActive) !important;
  padding-bottom: 0;
  border-bottom: 0.125em solid var(--blueActive);
}
